import ninegrid from "../index.js";

export class ngColumns
{
	#owner;

	constructor(owner) {
		this.#owner = owner;
	}

	count = () => {
		return this.#owner.activeTmpl.querySelectorAll("[data-bind]").length;
	}

	info = (v) => {

		const element2Info = (el) => {

			if (!el) return null;

			const ths = this.#owner.body.querySelectorAll(`thead [data-col="${el.dataset.col}"]`);

			return {
				"name": el.dataset.bind,
				"type": (el.dataset.type || "string").toLocaleLowerCase(),
				"desc": ths.length > 0 ? ths[ths.length - 1].getAttribute("title") : null,
			};
		}

		return v ?
			element2Info(this.#owner.activeTmpl.querySelector(`[data-bind="${v}"]`)) :
			Array.from(this.#owner.activeTmpl.querySelectorAll("[data-bind]")).filter(el => el.dataset.bind !== "rowState").map(el => element2Info(el));
	}
	
	
	#getCol = (tbl, col) => {
		
		var arr = Array.from(tbl.querySelectorAll("col"));
		return arr[col];
	};
	
	#getCells = (el, col1, col2) => {
		var r = [];
		if (!el) return r;
		
		for (var i = col1; i <= col2; i++) {
			r = r.concat(Array.from(el.querySelectorAll(`[data-col="${i}"]:not(.dummy)`)));
		}
		return r;
	};

	#getMoveTargetCell = (tr, sourceCell, targetCell) => {
		
		const getLeftCell_BAK = (tr, cell) => {
			const col		= parseInt(cell.dataset.col);
			const isTemplate= tr.closest("thead,tbody,tfoot") ? false : true;
			
			//var tds = isTemplate ? tr.querySelectorAll("th:not(.dummy),td:not(.dummy)") : tr.querySelectorAll("th:not(.tmp),td:not(.tmp)");
			var tds = isTemplate ? tr.querySelectorAll("th:not(.dummy):not(.tmp),td:not(.dummy):not(.tmp)") : tr.querySelectorAll("th:not(.dummy):not(.tmp),td:not(.dummy):not(.tmp)");
			//var tds = isTemplate ? tr.querySelectorAll("th:not(.dummy):not(.tmp),td:not(.tmp)") : tr.querySelectorAll("th:not(.tmp),td:not(.tmp)");
			for (var td of tds) {
				const tdCol		= parseInt(td.dataset.col);

				if (tdCol >= col) {
					return td;
				}
			}
		};
		const getLeftCell = (tr, cell) => {
			const col		= parseInt(cell.dataset.col);
			const isTemplate= tr.closest("thead,tbody,tfoot") ? false : true;
			
			return tr.querySelector(`[data-col="${col}"]`);
		};
		
		const getRightCell = (tr, cell) => {
			const col		= parseInt(cell.dataset.col);
			const colSpan	= cell.colSpan || 1;
			const isTemplate= tr.closest("thead,tbody,tfoot") ? false : true;
			
			var tds = isTemplate ? tr.querySelectorAll("th:not(.tmp),td:not(.tmp)") : tr.querySelectorAll("th:not(.tmp),td:not(.tmp)");
			for (var td of tds) {
				const tdCol		= parseInt(td.dataset.col);

				if (tdCol > col + colSpan - 1) {
					return td;
				}
			}
		};
		
		return (parseInt(sourceCell.dataset.col) > parseInt(targetCell.dataset.col)) ? getLeftCell(tr, targetCell) : getRightCell(tr, targetCell);
	};
	
	#getColumns = (cell) => {
		const r = {
			org : {
				thead : { cells: [], },
				tfoot : { cells: [], },
				tbody : { cells: [], },
				fixed : { cells: [], },
				cols : [],
			},
			thead : { cells: [], },
			tfoot : { cells: [], },
			tbody : { cells: [], },
			fixed : { cells: [], },
			template : { cells: [], },
			cols : [],
		};
		
		const colSpan = cell.colSpan || 1;
		const table = cell.closest("table");
		const col = parseInt(cell.dataset.col);
		const rowIndex = cell.closest("tr").sectionRowIndex;
		
		$(`thead tr`, table).each((i, tr) => {
			if (tr.sectionRowIndex < rowIndex && tr.sectionRowIndex != 0) return true; //.col-indicator 포함
			//if (tr.sectionRowIndex < rowIndex) return true; //.col-indicator 제외
			
			r.thead.cells = r.thead.cells.concat(this.#getCells(tr, col, col+colSpan-1));
		});
		
		r.tfoot.cells	= this.#getCells(table.querySelector("tfoot"), col, col+colSpan-1);
		r.tbody.cells	= this.#getCells(table.querySelector("tbody.bindable"), col, col+colSpan-1);
		r.fixed.cells	= this.#getCells(table.querySelector("tbody.fixed"), col, col+colSpan-1);
		
		const layout = this.#owner.shadowRoot.querySelector("ng-foot").shadowRoot.querySelector("ng-layout");
		r.org.thead.cells	= this.#getCells(layout.currentTable.querySelector("thead"),			col, col+colSpan-1);
		r.org.tfoot.cells	= this.#getCells(layout.currentTable.querySelector("tfoot"),			col, col+colSpan-1);
		r.org.tbody.cells	= this.#getCells(layout.currentTable.querySelector("tbody.bindable"),	col, col+colSpan-1);
		r.org.fixed.cells	= this.#getCells(layout.currentTable.querySelector("tbody.fixed"),		col, col+colSpan-1);
		
		this.#owner.template.each((i,tr) => {
			r.template.cells = r.template.cells.concat(this.#getCells(tr, col, col+colSpan-1));
		});

		for (var i = col; i <= col+colSpan-1; i++) {
			r.cols.push(this.#getCol(this.#owner.body, i));
		}
		
		for (var i = col; i <= col+colSpan-1; i++) {
			r.org.cols.push(this.#getCol(layout.currentTable, i));
		}

		return r;
	};
	
	#movable = (sourceCell, targetCell, source, target) => {

		if (sourceCell.closest("tr").rowIndex != targetCell.closest("tr").rowIndex) return false;
		
		const sourceCol		= parseInt(sourceCell.dataset.col);
		const sourceColSpan	= sourceCell.colSpan;
		
		const targetCol		= parseInt(targetCell.dataset.col);
		const targetColSpan	= targetCell.colSpan;

		
		for (var v of [source.thead.cells, source.tfoot.cells, source.tbody.cells, source.fixed.cells, source.template.cells]) {
			for (var cell of v) {
				const col		= parseInt(cell.dataset.col);
				const colSpan	= cell.colSpan;

				if (col < sourceCol) {
					return false;
				}
				
				if (col + colSpan - 1 > sourceCol + sourceColSpan - 1) {
					return false;
				}
			}	
		};
		
		return true;
	};
	
	moveColumn = (sourceCell, targetCell) => {
		
		if (!sourceCell || !targetCell) return false;

		const layout = this.#owner.shadowRoot.querySelector("ng-foot").shadowRoot.querySelector("ng-layout");

		/**
		 * colIndicator 미포함됨
		 */
		const source		= this.#getColumns(sourceCell);
		const target		= this.#getColumns(targetCell);
		
		const targetTable	= targetCell.closest("table");
		
		const bChangedLeft	= (sourceCell.closest(".ng-container-left") || targetCell.closest(".ng-container-left")) ? true : false;
		const bChangedRight	= (sourceCell.closest(".ng-container-right") || targetCell.closest(".ng-container-right")) ? true : false;
		
		if (!this.#movable(sourceCell, targetCell, source, target)) return false;
		
		
		
		//for (var v of [source.thead.cells, source.tfoot.cells, source.tbody.cells, source.fixed.cells, source.template.cells]) {
		for (var v of [source.thead.cells, source.tfoot.cells, source.tbody.cells, source.fixed.cells]) {
			for (var fromCell of v) {
				
				ninegrid.j.querySelectorAll(fromCell).addClass("tmp");
				
				const rowIndex = fromCell.closest("tr").rowIndex;
				const targetTr = targetTable.querySelectorAll("tr")[rowIndex];
				
				var toCell = this.#getMoveTargetCell(targetTr, sourceCell, targetCell);
				// body 끝 에서 이동시 toCell is null
				if (toCell) {
					targetTr.insertBefore(fromCell, toCell);
				}
				else {
					targetTr.appendChild(fromCell);
				}
				
				
			}
		};
		
		for (var v of [source.org.thead.cells, source.org.tfoot.cells, source.org.tbody.cells, source.org.fixed.cells]) {
			for (var fromCell of v) {
				
				ninegrid.j.querySelectorAll(fromCell).addClass("tmp");
				
				const targetTable	= fromCell.closest("table");
				const rowIndex		= fromCell.closest("tr").rowIndex;
				const targetTr		= targetTable.querySelectorAll("tr")[rowIndex];
				
				var toCell = this.#getMoveTargetCell(targetTr, sourceCell, targetCell);
				// body 끝 에서 이동시 toCell is null
				if (toCell) {
					targetTr.insertBefore(fromCell, toCell);
				}
				else {
					targetTr.appendChild(fromCell);
				}
			}
		};
		
		
		
		for (var fromCell of source.template.cells) {
			
			ninegrid.j.querySelectorAll(fromCell).addClass("tmp");
			
			//const rowIndex = fromCell.closest("tr").rowIndex;
			const targetTr = fromCell.closest("tr");
			
			var toCell = this.#getMoveTargetCell(targetTr, sourceCell, targetCell);
			
			// body 끝 에서 이동시 toCell is null
			if (toCell) {
				targetTr.insertBefore(fromCell, toCell);
			}
			else {
				targetTr.appendChild(fromCell);
			}
		}
		
		
		var colIndex;
		if (parseInt(sourceCell.dataset.col) > parseInt(targetCell.dataset.col)) {
			colIndex = parseInt(targetCell.dataset.col);
		}
		else {
			colIndex = parseInt(targetCell.dataset.col) + (targetCell.colSpan||1) - 1 + (parseInt(sourceCell.dataset.col) > parseInt(targetCell.dataset.col) ? 0 : 1);
		}
		
		let targetCol = this.#getCol(this.#owner.body, colIndex);
		
		const bSameTable = (targetCell.closest("table") == targetCol.closest("table")) ? true : false;

		for (var col of source.cols) {

			if (col) {
				if (bSameTable) {
					targetCell.closest("table").querySelector("colgroup").insertBefore(col, targetCol);
				}
				else {
					targetCell.closest("table").querySelector("colgroup").appendChild(col);
				}
			}
		}
		for (var col of source.org.cols) {
			targetCol = this.#getCol(layout.currentTable, colIndex);
			
			if (col) {
				col.closest("colgroup").insertBefore(col, targetCol);
			}
		}
		
		for (var v of [source.thead.cells, source.tfoot.cells, source.tbody.cells, source.fixed.cells]) {
			for (var fromCell of v) {
				ninegrid.j.querySelectorAll(fromCell).removeClass("tmp");
			}
		}
		
		for (var v of [source.org.thead.cells, source.org.tfoot.cells, source.org.tbody.cells, source.org.fixed.cells]) {
			for (var fromCell of v) {
				ninegrid.j.querySelectorAll(fromCell).removeClass("tmp");
			}
		}
		
		for (var fromCell of source.template.cells) {
			ninegrid.j.querySelectorAll(fromCell).removeClass("tmp");
		}
		
		
		this.#owner.body.querySelectorAll(".ng-container-left col").forEach(el => {
			el.setAttribute("fixed", "left");
		});
		this.#owner.body.querySelectorAll(".ng-container-left .col-indicator").forEach(el => {
			el.setAttribute("fixed", "left");
		});
		
		
		this.#owner.body.querySelectorAll(".ng-container-right col").forEach(el => {
			el.setAttribute("fixed", "right");
		});
		this.#owner.body.querySelectorAll(".ng-container-right .col-indicator").forEach(el => {
			el.setAttribute("fixed", "right");
		});

		this.#owner.body.querySelectorAll(".ng-container-body col").forEach(el => {
			el.removeAttribute("fixed");
		});
		this.#owner.body.querySelectorAll(".ng-container-right .col-indicator").forEach(el => {
			el.removeAttribute("fixed");
		});
		
		layout.currentTable.querySelectorAll("colgroup col").forEach(el => {
			el.removeAttribute("fixed");
		});
		
		
		
		$(`th,td`, this.#owner.template).each((i,td) => {
			td.removeAttribute("fixed");
		});
		$(`th,td`, layout.currentTable).each((i,td) => {
			td.removeAttribute("fixed");
		});
		
		this.#owner.body.querySelectorAll(".ng-container-left .col-indicator").forEach(el => {
			$(`[data-col="${el.dataset.col}"]`, this.#owner.template).each((i,td) => {
				td.setAttribute("fixed", "left");
			});
			
			$(`[data-col="${el.dataset.col}"]`, layout.currentTable).each((i,td) => {
				td.setAttribute("fixed", "left");
			});
			
			$(`colgroup col`, layout.currentTable).each((i,col) => {
				if (i <= parseInt(el.dataset.col)) {
					col.setAttribute("fixed", "left");
				}
			});
		});
		this.#owner.body.querySelectorAll(".ng-container-right .col-indicator").forEach(el => {
			$(`[data-col="${el.dataset.col}"]`, this.#owner.template).each((i,td) => {
				td.setAttribute("fixed", "right");
			});
			
			$(`[data-col="${el.dataset.col}"]`, layout.currentTable).each((i,td) => {
				td.setAttribute("fixed", "right");
			});
		});

		this.#owner.resetTemplate();
		
		this.#owner.body.querySelectorAll(".ng-container-right .col-indicator").forEach(el => {
			
			$(`colgroup col`, layout.currentTable).each((i,col) => {
				if (i >= parseInt(el.dataset.col)) {
					col.setAttribute("fixed", "right");
				}
			});
		});
		
		if (bChangedLeft) {
			var w = (targetCell.closest(".ng-container-body")) ? -sourceCell.offsetWidth : 0;
			$(`.ng-container-left .col-indicator`, this.#owner.body).each((i,el) => { w += el.offsetWidth; });
			$(`.ng-container-left`, this.#owner.body).css({ "width": w, "min-width": w, });
		}
		if (bChangedRight) {
			var w = (targetCell.closest(".ng-container-body")) ? -sourceCell.offsetWidth : 0;
			$(`.ng-container-right .col-indicator`, this.#owner.body).each((i,el) => { w += el.offsetWidth; });
			$(`.ng-container-right`, this.#owner.body).css({ "width": w, "min-width": w, });
		}
		
		this.#owner.refreshData();
	}
	
	width = (colIndex, colWidth) => {
		
		colWidth = parseFloat(colWidth);

		const col				= this.#owner.body.querySelector(`colgroup col[data-col="${colIndex}"]`);
		const isLeftContainer	= col.closest(".ng-container-left") ? true : false;
		const isRightContainer	= col.closest(".ng-container-right") ? true : false;
		const isBodyContainer	= col.closest(".ng-container-body") ? true : false;
		const group				= isLeftContainer ? "left" : (isRightContainer ? "right" : "body");

		if (isBodyContainer) {
			if (this.#owner.getAttribute("auto-fit-col") == "true") {
				var totalWidth = 0;
				$(`.ng-container-body .col-indicator`, this.#owner.body).not(`[data-col=${colIndex}]`).each((i,el) => { totalWidth += el.offsetWidth; });
				const tableWidth = $('.ng-container-body', this.#owner.body).width();
				
				$(".ng-container-body col", this.#owner.body).each((i,col) => {
					var w = parseInt( (colIndex == col.dataset.col) ? colWidth : col.getAttribute("width")) * tableWidth / totalWidth;
					col.setAttribute("width", w);
				});
			}
			else {
				col.setAttribute("width", colWidth);
			}
		}
		else {
			var w = 0;
			
			$(`.ng-container-${group} .col-indicator`, this.#owner.body).not(`[data-col=${colIndex}]`).each((i,el) => { w += parseInt(el.offsetWidth); });
			$(`.ng-container-${group}`, this.#owner.body).css({ "width": parseInt(w + colWidth), "min-width": parseInt(w + colWidth), });
			
			col.setAttribute("width", colWidth);
		}
	}
}